// extracted by mini-css-extract-plugin
export default {"container":"ConfiguratorActions__container___pJPYL","buttonAddToCart":"ConfiguratorActions__buttonAddToCart___nP1xR"};